export enum BookingScreenType {
  Default = 'DEFAULT',
  Book = 'BOOK',
  Treatment = 'TREATMENT',
  PainDetails = 'PAIN_DETAILS',
  DetailedView = 'DETAILED_VIEW',
  Upselling = 'UPSELLING',
}
